import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack, Grid, Modal, Box } from '@mui/material';
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../../Redux/UserMaintanence";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 670,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  alignItems: "center",
};
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          {/* <CloseIcon /> */}
          <img
            src={process.env.PUBLIC_URL + "images/Home/close_img.png"}
            alt="icon"
            className="form_close_img"
          />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#7500C0"),
  backgroundColor: "#7500C0",
  "&:hover": {
    backgroundColor: "#7500C0",
    color: "#fff",
  },
}));

function AddUser(props) {
  const dispatch = useDispatch();
  const [newUser, setNewUser] = useState("");
  const [newSuper, setNewSuper] = useState("");
  const [isUserNameNull, setIsUserNameNull] = useState(false);
  const [isSuperNameNull, setIsSuperNameNull] = useState(false);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);
  const [openUserModal, setOpenUserModal] = useState(false)
  const initData = useSelector((state) => state.userRoles.UserMaintanenceData);

  const [isDuplicateUser, setIsDuplicateUser] = useState(false);
  const [isUserAddedSuccess, setIsUserAddedSuccess] = useState(false);

  const openModalHandle = () =>{
    setOpenUserModal(true)
}
// const addUser = {
// username:'',
// supname:''
// }
  const handleClose = () => {
    setOpenUserModal(false);
    setNewUser("");
    setNewSuper("");
    setIsAddUserOpen(false);
    setIsDuplicateUser(false);
    setIsUserAddedSuccess(false);
    // dispatch(getUserMaintanenceData());
  };
  //  function to save the qa's
  const isValidEmailFormat = (email) => {
    const regex = /^[a-z]+(\.[a-z]+)*[a-z]+\.[a-z]+$/;
    return regex.test(email);
  };
  console.log('user', newUser,'enter', initData)
  const saveAddHandle = () => {
    if (newUser == "") {
      setIsUserNameNull(true);
      setIsAddUserOpen(true);
      // dispatch(getUserMaintanenceData());
    } else if (newSuper == "") {
      setIsSuperNameNull(true);
      setIsAddUserOpen(true);
    }
    if (newUser != "" && newSuper != "") {
      if (props.initData?.some((item) => item.Enterprise_ID === newUser)) {
        setIsDuplicateUser(true);
      } else {
        console.log(newUser + " " + newSuper, " neww Userr");
        dispatch(addUser(newUser, newSuper));
        setIsUserNameNull(false);
        setIsSuperNameNull(false);
        setNewUser("");
        setNewSuper("");
        // props.setOpenEdit(false);
        setIsUserAddedSuccess(true);
        // setIsAddUserOpen(false);
      }
    }
    // setIsDuplicateUser(false);
  };

  return (
     <div className='user-container'>
    {/* <Button variant='contained' onClick={openModalHandle} sx={{backgroundColor:"#8a2be2"}}>
        Add User
    </Button> */}
    <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            // autoFocus
            onClick={openModalHandle}
          >
            Add User
          </ColorButton>
    <Modal 
    open = {openUserModal}
    onClose={handleClose}
    >
      <Box sx={style}>
      {/* <form onSubmit={handleSubmit}> */}
      {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 400, margin: 'auto' }}> */}
        {!isDuplicateUser && !isUserAddedSuccess ? (
          <DialogContent sx={{ paddingTop: "15px", width: "600px" }}>
            <Stack sx={{ padding: "10px", marginTop: "10px" }} spacing={2}>
              <Stack spacing={1} sx={{ alignItems: 'center'}}>
                <Typography sx={{ fontSize: "14px", color: "#000000" }}>
                  Enter Enterprise ID <span style={{ color: "#A80011" }}>*</span>
                </Typography>
                <TextField
                  error={isUserNameNull && isAddUserOpen ? true : false}
                  required={isUserNameNull && isAddUserOpen ? false : true}
                  className="coursecode-textfield"
                  size="small"
                  fullWidth
                  multiline
                  id={
                    isUserNameNull && isAddUserOpen
                      ? "outlined-error"
                      : "outlined-required"
                  }
                  variant="outlined"
                  helperText={
                    isUserNameNull && isAddUserOpen
                      ? "Please enter the user name"
                      : null
                  }
                  onChange={(e) => {
                    setNewUser(e.target.value);
                    if (newUser !== "") {
                      setIsUserNameNull(false);
                      isValidEmailFormat(e.target.value)
                    }
                  }}
                  // onBlur={isValidEmailFormat}
                  sx={{ width: "100%", fontSize: "14px !important" , alignItems:'center'}}
                />
                <Typography sx={{ fontSize: "14px", color: "#000000" }}>
                  Enter Supervisor ID <span style={{ color: "#A80011" }}>*</span>
                </Typography>

                <TextField
                  error={isSuperNameNull && isAddUserOpen ? true : false}
                  required={isSuperNameNull && isAddUserOpen ? false : true}
                  className="coursecode-textfield"
                  size="small"
                  fullWidth
                  multiline
                  id={
                    isSuperNameNull && isAddUserOpen
                      ? "outlined-error"
                      : "outlined-required"
                  }
                  variant="outlined"
                  helperText={
                    isSuperNameNull && isAddUserOpen
                      ? "Please enter the supervisor name"
                      : null
                  }
                  onChange={(e) => {
                    setNewSuper(e.target.value);
                    if (newSuper !== "") {
                      setIsSuperNameNull(false);
                    }
                  }}
                  sx={{ width: "100%", fontSize: "14px !important" , alignItems:'center'}}
                />
                <Typography sx={{ fontSize: "12px" }}>
                  <span style={{ color: "#A80011" }}>
                    Please enter ID's without appending @accenture.com
                  </span>
                </Typography>
              </Stack>
            </Stack>
          </DialogContent>
        ) : isUserAddedSuccess && !isDuplicateUser ? (
          <DialogContent
            sx={{ paddingTop: "15px", paddingBottom: "15px", width: "600px" }}
          >
            {console.log(isUserAddedSuccess, " is User Added Successfully ! ")}
            <Stack
              sx={{ padding: "10px", marginTop: "10px" }}
              spacing={2}
            ></Stack>
            <Typography sx={{ fontSize: "14px", textAlign: "center" }}>
              User Added Successfully!
            </Typography>
          </DialogContent>
        ) : (
          <DialogContent
            sx={{ paddingTop: "15px", paddingBottom: "15px", width: "600px" }}
          >
            <Stack
              sx={{ padding: "10px", marginTop: "10px" }}
              spacing={2}
            ></Stack>
            <Typography sx={{ fontSize: "14px", textAlign: "center" }}>
              The user has already got access!
            </Typography>
          </DialogContent>
        )}
        {!isDuplicateUser && !isUserAddedSuccess ? (
          <DialogActions
            sx={{
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <ColorButton
              variant="contained"
              className="save-button"
              size="small"
              sx={{ background: "#7500C0", color: "white" }}
              autoFocus
              onClick={saveAddHandle}
            >
              Submit
            </ColorButton>
            <ColorButton
              variant="contained"
              className="cancel-button"
              size="small"
              sx={{
                background: "white",
                color: "#7500C0",
                border: "solid 1px #7500C0",
              }}
              autoFocus
              onClick={handleClose}
            >
              Cancel
            </ColorButton>
          </DialogActions>
        ) : (
          <DialogActions
            sx={{
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <ColorButton
              variant="contained"
              className="cancel-button"
              size="small"
              sx={{
                background: "white",
                color: "#7500C0",
                border: "solid 1px #7500C0",
              }}
              autoFocus
              onClick={handleClose}
            >
              Ok
            </ColorButton>
          </DialogActions>
        )}
      </Box>
    {/* </form> */}
  {/* </Box> */}
    </Modal>
    </div>
  );
}

export default AddUser;
